import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { MessageModule } from '../../../components/message/message.module';
import { NotificationCellModule } from '../../components/notification-cell/notification-cell.module';
import { SegmentedNavigationModule } from '../../components/segmented-navigation/segmented-navigation.module';
import { QuestionsComponent } from './questions.component';
import { QuestionsRoutingModule } from './questions-routing.module';

@NgModule({
  declarations: [QuestionsComponent],
  imports: [
    CommonModule,
    SegmentedNavigationModule,
    QuestionsRoutingModule,
    NgxBootstrapIconsModule,
    BsDropdownModule,
    MessageModule,
    NotificationCellModule,
  ],
})
export class QuestionsModule {}
